var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareemThinArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.08751C1 8.98497 1.03923 8.88244 1.12149 8.80348L6.20624 3.82174C6.40492 3.61903 6.69598 3.5 6.9997 3.5C7.30342 3.5 7.59448 3.61903 7.79949 3.82764L12.8779 8.80348C13.0462 8.96612 13.0399 9.22658 12.8627 9.38686C12.6843 9.54361 12.4046 9.53654 12.235 9.37154L7.15156 4.39098C7.09461 4.33206 7.0326 4.32499 6.9997 4.32499C6.9668 4.32499 6.90605 4.33206 6.85417 4.38509L1.76436 9.37154C1.59478 9.53654 1.31511 9.54361 1.13667 9.38686C1.04556 9.30554 1 9.19711 1 9.08751Z",
    fill: "#001411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareemThinArrowUp);
export default __webpack_public_path__ + "static/media/careem-thin-arrow-up.42cb66b8fe0caba7612d08244dadba57.svg";
export { ForwardRef as ReactComponent };